import { defineStore } from 'pinia'

export const usePesquisaStore = defineStore('pesquisa', {
    state: () => ({
        estaAbertaPesquisa: false,
        estaAbertoMenu: false,
    }),

    actions: {
        setEstaAbertaPesquisa(valor) {
            this.estaAbertaPesquisa = valor
        },
        setEstaAbertoMenu(valor) {
            this.estaAbertoMenu = valor
        },
    },
})
